import React from 'react';
import {
  useGetMessageCountMutation,
  useGetAllAlertsMutation,
  useGetStudentsMutation,
  useUpdateEmailIdMutation,
  useGetEmailMutation
} from '../../features/authentication/authApiSlice';
import PropTypes from 'prop-types';
import {
  useGetMessageGroupMutation,
  useMessageGroupNameUpdateMutation,
  useMessageGroupDeleteMutation,
  useMessageGroupCreateMutation,
  useGetMessageGroupMembersMutation,
  useAddingGroupMembersMutation,
  useRemovingGroupMembersMutation,
  useSendMessageMutation,
  useMessageDeleteMutation,
  useMessageBulkDeleteMutation
} from '../../features/authentication/messageApiSlice';
import CustomToast from '../../components/Toast';
import {
  useGetAssignmentShareUsersMutation,
  useShareAssignmentsMutation
} from '../../features/authentication/assignApiSlice';
const dashboardContext = React.createContext();

export const DashboardProvider = ({ children }) => {
  const [getMessageCount] = useGetMessageCountMutation();
  const [getMessageGroup] = useGetMessageGroupMutation();
  const [messageGroupNameUpdate] = useMessageGroupNameUpdateMutation();
  const [messageGroupDelete] = useMessageGroupDeleteMutation();
  const [messageGroupCreate] = useMessageGroupCreateMutation();
  const [getMessageGroupMembers] = useGetMessageGroupMembersMutation();
  const [addingGroupMembers] = useAddingGroupMembersMutation();
  const [removingGroupMembers] = useRemovingGroupMembersMutation();
  const [getStudents] = useGetStudentsMutation();
  const [sendMessage] = useSendMessageMutation();
  const [messageDelete] = useMessageDeleteMutation();
  const [messageBulkDelete] = useMessageBulkDeleteMutation();
  const [updateEmailId] = useUpdateEmailIdMutation();
  const [getAllAlerts] = useGetAllAlertsMutation();
  const [getAssignmentShareUsers] = useGetAssignmentShareUsersMutation();
  const [shareAssignment] = useShareAssignmentsMutation();
  const [getEmail] = useGetEmailMutation();

  const [allMessageCount, setAllMessageCount] = React.useState(null);
  const [notViewedAlerts, setNotViewedAlerts] = React.useState(0);
  const [sendEmailModal, setSendEmailModal] = React.useState(false);
  const [allMessage, setAllMessage] = React.useState([]);
  const [updateEmailModal, setUpdateEmailModal] = React.useState(false);
  const [selectRecipient, setSelectRecipient] = React.useState(false);
  const [createDist, setCreateDist] = React.useState(false);
  const [manageDis, setManageDist] = React.useState(false);
  const [manageDisList, setManageDisList] = React.useState(false);
  const [activeButton, setActiveButton] = React.useState('Date');
  const [search, setSearch] = React.useState('');
  const [allMessageGroup, setallMessageGroup] = React.useState([]);
  const [slectedGroupId, setSlectedGroupId] = React.useState(null);
  const [allStudents, setallStudents] = React.useState([]);
  const [allAssignmentShareUsers, setAllAssignmentShareUsers] = React.useState([]);
  const [slectedStudents, setSlectedStudents] = React.useState([]);
  const [noOFInboxMessage, setNoOFInboxMessage] = React.useState(0);
  const [noOFOutboxMessage, setNoOFOutboxMessage] = React.useState(0);
  const [selectedGroupName, setSelectedGroupName] = React.useState('');
  const [searchValue, setSearchValue] = React.useState('');
  const [intialAddingSelectedStudents, setIntialAddingSelectedStudents] = React.useState([]);
  const [intialRomovingSelectedStudents, setIntialRomovingSelectedStudents] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const [limit, setLimit] = React.useState(10);
  const [skip, setSkip] = React.useState(0);
  const [email, setEmail] = React.useState('');
  const [successNotification, setSuccessNotification] = React.useState(false);
  const [isReplayMessage, setIsReplayMessage] = React.useState(false);

  const [messageDetail, setMessageDetail] = React.useState({
    selectedMessages: [],
    allInboxChecked: false
  });
  const [allMessageGroupMembers, setallMessageGroupMembers] = React.useState([]);
  const [studentId, setStudentId] = React.useState('');
  const [isSchoolChange, setIsSchoolChange] = React.useState(new Date().getSeconds());

  const loadAllMessageGroup = async () => {
    if (!isLoading) {
      setIsLoading(true);
      try {
        const allMessageGroupResponse = await getMessageGroup().unwrap();
        setallMessageGroup(() => allMessageGroupResponse);
      } catch (ex) {
        if (!ex?.status) {
          console.log('No server response');
        } else {
          console.log('Login failed');
        }
      }
      setIsLoading(false);
    }
  };

  const createMessageGroup = async (name, studentIds) => {
    const option = {
      name,
      studentIds
    };
    if (!isLoading) {
      setIsLoading(true);
      try {
        const allMessageGroupResponse = await messageGroupCreate(option).unwrap();
        setallMessageGroup(() => allMessageGroupResponse);
        await loadAllMessageGroup();
        CustomToast('Message group created successfully', 'success');
        setIsLoading(false);
      } catch (ex) {
        if (!ex?.status) {
          console.log('No server response');
        } else {
          if (ex.data !== null) {
            CustomToast(ex.data, 'info');
            setIsLoading(false);
          }
        }
      }
    }
  };

  const getAllStudents = async () => {
    try {
      const allStudentsResponse = await getStudents().unwrap();
      setallStudents(() => allStudentsResponse);
    } catch (ex) {
      if (!ex?.status) {
        console.log('No server response');
      } else {
        console.log('Login failed');
      }
    }
  };

  const getAllAssignmentShareUsers = async (text) => {
    try {
      const options = {
        searchText: text
      };
      const allAssignmentShareUsersResponse = await getAssignmentShareUsers(options).unwrap();
      setAllAssignmentShareUsers(allAssignmentShareUsersResponse);
    } catch (ex) {
      if (!ex?.status) {
        console.log('No server response');
      } else {
        console.log('Login failed');
      }
    }
  };

  const setShareAssignments = async (assignmentId) => {
    const memberId = slectedStudents.map((item) => item.studentId);
    try {
      const options = {
        assignmentIds: assignmentId,
        memberIds: memberId
      };
      const response = await shareAssignment(options);
      if(response.error)
      {
        if(response.error.data?.error)
          CustomToast(response.error.data.error, 'error');
        else
          CustomToast('Share Assignment Failed.', 'error');
      }
      else if (response.data.status === 'Warning') {
        CustomToast(response.data.message, 'warning');
      } else {
        CustomToast(response.data.message, 'success');
      }
    } catch (ex) {
      if (!ex?.status) {
        console.log('No server response');
      } else {
        console.log('Login failed');
      }
    }
  };

  const updateMessageGroupName = async (id, name) => {
    if (!isLoading) {
      setIsLoading(true);
      try {
        const allMessageGroupResponse = await messageGroupNameUpdate({
          id,
          name
        }).unwrap();
        setallMessageGroup(() => allMessageGroupResponse);
        await loadAllMessageGroup();
        CustomToast('Message group name updated successfully', 'success');
      } catch (ex) {
        if (!ex?.status) {
          console.log('No server response');
        } else {
          console.log('Login failed');
        }
      }
      setIsLoading(false);
    }
  };

  const deleteMessageGroup = async (id) => {
    try {
      const allMessageGroupResponse = await messageGroupDelete(id).unwrap();
      setallMessageGroup(() => allMessageGroupResponse);
      await loadAllMessageGroup();
      CustomToast('Message group deleted successfully', 'success');
    } catch (ex) {
      if (!ex?.status) {
        console.log('No server response');
      } else {
        console.log('Login failed');
      }
    }
  };

  async function getMessageCountAsync() {
    try {
      const messageCountResponse = await getMessageCount().unwrap();
      setAllMessageCount(() => messageCountResponse);
      setNotViewedAlerts(() => messageCountResponse.notViewedAlerts);
    } catch (ex) {
      if (!ex?.status) {
        console.log('No server response');
      } else {
        console.log('Login failed');
      }
    }
  }

  async function getEmailAsync() {
    try {
      const emailResponse = await getEmail().unwrap();
      setEmail(emailResponse.email);
    } catch (ex) {
      console.log(ex);
    }
  }

  async function getAllAlertsAsync(type, sort, text, take = 5, skip = 0) {
    try {
      const allAlertsResponse = await getAllAlerts({
        skip: skip,
        take: take,
        viewType: type,
        orderBy: sort,
        searchText: text
      }).unwrap();
      setAllMessage(() => allAlertsResponse.data);
    } catch (ex) {
      if (!ex?.status) {
        console.log('No server response');
      } else {
        console.log('Login failed');
      }
    }
  }

  const loadMessageGroupMembers = async (id) => {
    if (!isLoading) {
      setIsLoading(true);
      try {
        const allMessageGroupResponse = await getMessageGroupMembers(id).unwrap();
        setallMessageGroupMembers(() => allMessageGroupResponse);
      } catch (ex) {
        if (!ex?.status) {
          console.log('No server response');
        } else {
          console.log('Login failed');
        }
      }
      setIsLoading(false);
    }
  };

  const addGroupMembers = async (messageGroupId, userIds) => {
    try {
      const allMessageGroupResponse = await addingGroupMembers({
        messageGroupId,
        userIds
      }).unwrap();
      setallMessageGroupMembers(() => allMessageGroupResponse);
      await loadMessageGroupMembers(messageGroupId);
      CustomToast('Members added successfully', 'success');
    } catch (ex) {
      if (!ex?.status) {
        console.log('No server response');
      } else {
        if (ex.data) {
          CustomToast(ex.data, 'info');
        }
      }
    }
  };

  const removeGroupMembers = async (messageGroupId, userIds) => {
    try {
      const allMessageGroupResponse = await removingGroupMembers({
        messageGroupId,
        userIds
      }).unwrap();
      setallMessageGroupMembers(() => allMessageGroupResponse);
      CustomToast('Members removed successfully', 'success');
      await loadMessageGroupMembers(messageGroupId);
    } catch (ex) {
      if (!ex?.status) {
        console.log('No server response');
      } else {
        console.log('Login failed');
      }
    }
  };

  const sendMessageHandler = async (message) => {
    try {
      const sendMessageResponse = await sendMessage(message).unwrap();
      console.log(sendMessageResponse);
      setSlectedStudents(() => []);
      setSuccessNotification(true);
    } catch (ex) {
      if (!ex?.status) {
        console.log('No server response');
      } else {
        console.log('Login failed');
      }
    }
  };

  const deleteHandler = async (messageId) => {
    const id = messageId[0] ? messageId[0] : messageId;
    try {
      const deleteMessageResponse = await messageDelete(id).unwrap();
      console.log(deleteMessageResponse);
      CustomToast('Message deleted successfully', 'success');
    } catch (ex) {
      if (!ex?.status) {
        console.log('No server response');
      } else {
        console.log('Login failed');
      }
    }
  };

  const messageBulktDeleteHandler = async () => {
    try {
      const deleteMessageResponse = await messageBulkDelete(
        messageDetail.selectedMessages
      ).unwrap();
      console.log(deleteMessageResponse);
      CustomToast('Message deleted successfully', 'success');
      setMessageDetail({
        ...messageDetail,
        selectedMessages: [],
        allInboxChecked: false
      });
    } catch (ex) {
      if (!ex?.status) {
        console.log('No server response');
      } else {
        console.log('Login failed');
      }
    }
  };
  return (
    <dashboardContext.Provider
      value={{
        allMessageCount,
        allMessage,
        allMessageGroup,
        setallMessageGroup,
        getMessageCountAsync,
        loadAllMessageGroup,
        getAllAlertsAsync,
        sendEmailModal,
        setSendEmailModal,
        setAllMessage,
        updateEmailModal,
        setUpdateEmailModal,
        selectRecipient,
        setSelectRecipient,
        createDist,
        setCreateDist,
        manageDis,
        setManageDist,
        manageDisList,
        setManageDisList,
        activeButton,
        setActiveButton,
        search,
        setSearch,
        updateMessageGroupName,
        deleteMessageGroup,
        createMessageGroup,
        setSlectedGroupId,
        slectedGroupId,
        allMessageGroupMembers,
        loadMessageGroupMembers,
        allStudents,
        getAllStudents,
        removeGroupMembers,
        addGroupMembers,
        setSlectedStudents,
        slectedStudents,
        sendMessageHandler,
        deleteHandler,
        messageBulktDeleteHandler,
        messageDetail,
        setMessageDetail,
        noOFInboxMessage,
        setNoOFInboxMessage,
        noOFOutboxMessage,
        setNoOFOutboxMessage,
        setIntialRomovingSelectedStudents,
        intialRomovingSelectedStudents,
        setIntialAddingSelectedStudents,
        intialAddingSelectedStudents,
        setSelectedGroupName,
        selectedGroupName,
        setSearchValue,
        searchValue,
        getAllAssignmentShareUsers,
        allAssignmentShareUsers,
        setAllAssignmentShareUsers,
        setShareAssignments,
        studentId,
        setStudentId,
        isLoading,
        setIsLoading,
        isSchoolChange,
        setIsSchoolChange,
        notViewedAlerts,
        setLimit,
        limit,
        skip,
        setSkip,
        getEmailAsync,
        email,
        setEmail,
        successNotification,
        setSuccessNotification,
        isReplayMessage,
        setIsReplayMessage
      }}>
      {children}
    </dashboardContext.Provider>
  );
};

DashboardProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export const useDashboardContext = () => React.useContext(dashboardContext);
